<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <div class="card-custom-web">
              <br />  <br />

              <h4 style="color: #000; text-align: left" class="custom-user-grade">
                Set the frequency of the class
              </h4>
              
              <div class="list-grade" v-for="item in freq" v-bind:key="item.id">
                <div style="width: 90%" class="float-left" >                    
                  <label class="ml-3"> {{ item.Name }} </label>
                </div>
                <div style="width: 10%" class="float-right">
                  <input type="radio" :value="item.Id" v-model="freqSelected" />
                </div>
                <div style="clear: both"></div>
                <hr />
              </div>

              <div class="bottom-center text-center">
                <CButton  style="
                  position: fixed;
                  bottom: 30px;
                  left: 0px;
                  right: 0px;
                  text-align: center;
                  margin: 0 auto;
                  " color="info" class="btn-select-blue mt-5" @click="insertFrequency(scheduleId, freqSelected)">
                  Save
                </CButton>

                <!-- kalau credit tak cukup -->
                <!-- <CButton  style="
                  position: fixed;
                  bottom: 30px;
                  left: 0px;
                  right: 0px;
                  text-align: center;
                  margin: 0 auto;
                  " color="info" class="btn-select-blue mt-5" @click="GoToTopup()">
                  Topup Credit
                </CButton> -->
              </div>

            </div>
          </div>
        </div>
      </CContainer>
      
      <div class="header-top">Tutor Detail</div>
      <div class="header-left">
        <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      </div>
      <div style="clear: both"></div>
      
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        SessionRemaining: false,
        UploadModal: false,
        students: [],
        user: {},
        freqSelected: "",
        freq: [],
        parent: [],
        scheduleId: this.$route.query.scheduleId,
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
    methods: {
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              // this.GetAuthorizeProfile(this.user.id);
            //   this.GetListChild(this.user.id);
              this.GetParentDetail(this.user.id);
              this.GetProfileStudentsByStudentId();
              this.GetFrequency();
              this.GetTimeTableTeacher(this.user.id);
            }
          });
      },
      GetProfileStudentsByStudentId() {
        this.$API
          .get(
            this.$GetStudentDetailByStudentId +
              "?studentId=" +
              this.$route.query.studentId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.students = response.data;
            }
          });
      },

      GetFrequency() {
        this.$API
          .get(
            this.$GetClassFrequency ,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.freq = response.data;
            }
          });
      },

      GetParentDetail() {
        this.$API
          .get(this.$GetParentDetailByUserId + "?id=" + this.user.id, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.parent = response.data;
            }
          });
      },

      GetTimeTableTeacher() {
      this.$API
        .get(this.$ScheduleTeacherWeb + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
            // console.log("TRY", this.classes);
          }
        });
      },

      insertFrequency: function (scheduleId, sessionSelected) {
        const formData = new FormData();
        // var test = scheduleId;
        // console.log("TRY", test);
        for (let index = 0; index < this.classes.length; index++) {
            var element = this.classes[index];
            // console.log("TRY", element);

            if(element.id == scheduleId) {
                console.log("TRY", element);
            
                var date = moment(element.start).format('YYYY-MM-DD');
                var time = moment(element.start).format('hh:mm:ss');

                formData.append("scheduleId", element.id);
                formData.append("dates", date);
                formData.append("times", time);
                formData.append("vcLink", element.joinLink);
                formData.append("meetingId", element.meetingId);
                formData.append("password", element.password);
                formData.append("sessionId", sessionSelected);
                formData.append("frequencyId", freqSelected);
                formData.append("isCheck", true);

                return this.$API
                .post(this.$TutorEditSchedule, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    console.log(response.status);
                    console.log(response.data);
                    if(response.status == 200 && response.data != null) {
                      this.$dialog
                      .alert("Request Sent.")
                      this.GoToRecurrence();
                    } else {
                    this.Message = response.data.Message;
                    this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                    console.log(error.response.data);
                    this.Error = true;
                    this.Message = error;
                    this.Message = "Error";
                    this.Message = response.data.Message;
                    this.ErrorMessage = true;
                    }
                });
    }
            
        }
      },
    
      GoBack() {
        this.$router.back();
      },
    
    },
  };
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #e0e0e0;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  
  .class-teach-name {
    padding: 4px 1px;
    top: 45px;
    /* height: 40px; */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  
    /* Pure/White */
  
    color: #ffffff;
  
    /* Inside auto layout */
  
    /* flex: none;
    order: 0;
    flex-grow: 0; */
  }
  .custom-btn-add {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
  
    color: #007cef;
  }
  .custom-btn-deactive {
    position: absolute;
    left: 0%;
    right: 0.61%;
    top: 0%;
    bottom: 0%;
  
    /* Body/1/Semibold */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    /* identical to box height, or 24px */
  
    color: #f85954;
  }
  .custom-text-deactive {
    position: absolute;
    width: 162px;
    height: 22px;
    left: 107px;
    top: 25px;
  
    /* Title/1/Semibold */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height */
  
    text-align: center;
  
    /* Black/Dark-001 */
  
    color: #000a2c;
  }
  </style>